import React, { useRef, useState } from 'react'
import { TextField, Button } from '@adobe/react-spectrum'
import BackButton from '../components/BackButton'
import { findLicense, updateLicense } from '../api/database-api'

export default function Trial() {
  const [loading, setLoading] = useState()
  const licenseFromRef = useRef()
  const trialEndRef = useRef()

  const onSaveClicked = async () => {
    const licenseTo = licenseFromRef.current.getInputElement().value
    const trialEnd = trialEndRef.current.getInputElement().value

    if (!licenseTo || !trialEnd) {
      window.alert('Fill out all fields.')
      return
    }

    setLoading(true)
    try {
      await findLicense(licenseTo)
      await updateLicense(licenseTo, {
        trialEnds: new Date(trialEnd).getTime(),
      })
      licenseFromRef.current.getInputElement().value = ''
      trialEndRef.current.getInputElement().value = ''
      window.alert('Trial updated successfully.')
    } catch (error) {
      window.alert("License with given ID doesn't exist.")
      console.error(error)
    }
    setLoading(false)
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        padding: 16,
        maxWidth: 400,
      }}
    >
      <BackButton />
      <span style={{ marginBottom: 8 }}>Add trial days to license.</span>
      <TextField ref={licenseFromRef} label="License" />
      <TextField ref={trialEndRef} type="date" name="date" label="Trial Ends" />
      <Button
        variant="cta"
        marginTop="size-200"
        marginBottom="size-300"
        isDisabled={loading}
        onPress={onSaveClicked}
      >
        Save
      </Button>
    </div>
  )
}
